var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "ml-3 mb-0 mt-0 pt-3 pb-0",
          attrs: { cols: "12", sm: "12", md: "4" }
        },
        [
          !_vm.disableCsvOutput
            ? _c(
                "v-btn",
                {
                  attrs: { depressed: "", type: "button" },
                  on: { click: _vm.csvOutputButtonClick }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(
                          "view.sales_force.reflect.button_caption.csv_output"
                        )
                      ) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mt-0 ml-3",
              attrs: { depressed: "", type: "button" },
              on: { click: _vm.reCorrectUrlButtonClick }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("view.sales_force.reflect.button_caption.re_correct")
                  ) +
                  "\n        "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        {
          staticClass: "mb-0 mt-0 pt-3 pb-0",
          attrs: { cols: "12", sm: "12", md: "4" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: {
                depressed: "",
                block: true,
                type: "submit",
                color: "#11479B",
                dark: true
              },
              on: { click: _vm.reflectButtonClick }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "view.sales_force.reflect.button_caption.sales_force"
                    )
                  ) +
                  "\n        "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6114a36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6114a36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/SalesForceButtonArea.vue
// module id = fWRI
// module chunks = 1